import { render, staticRenderFns } from "./ApplicationVersion.vue?vue&type=template&id=1625e449&"
import script from "./ApplicationVersion.vue?vue&type=script&lang=ts&"
export * from "./ApplicationVersion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports